import { render, staticRenderFns } from "./ProductPageScreenGiftcard.vue?vue&type=template&id=224e17a3&scoped=true&"
import script from "./ProductPageScreenGiftcard.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenGiftcard.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenGiftcard.vue?vue&type=style&index=0&id=224e17a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224e17a3",
  null
  
)

export default component.exports